var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit, } from '@angular/core';
import { Datastore, EntryAction, } from '@freelancer/datastore';
import { PaymentsCart, } from '@freelancer/payments-cart';
import { ButtonColor } from '@freelancer/ui/button';
import { HeadingType } from '@freelancer/ui/heading';
import { IconColor, IconSize } from '@freelancer/ui/icon';
import { Margin } from '@freelancer/ui/margin';
import { PictureDisplay, PictureObjectFit } from '@freelancer/ui/picture';
import { RibbonColor, RibbonOrientation, RibbonPlacement, } from '@freelancer/ui/ribbon';
import { FontColor, FontType, FontWeight, TextSize } from '@freelancer/ui/text';
import { EntryStatusApi } from 'api-typings/contests/contests';
import { ContextTypeApi, DestinationApi } from 'api-typings/payments/payments';
var ContestMultiAwardModalComponent = /** @class */ (function () {
    function ContestMultiAwardModalComponent(datastore, cart) {
        this.datastore = datastore;
        this.cart = cart;
        this.ButtonColor = ButtonColor;
        this.FontColor = FontColor;
        this.TextSize = TextSize;
        this.FontType = FontType;
        this.FontWeight = FontWeight;
        this.HeadingType = HeadingType;
        this.IconColor = IconColor;
        this.IconSize = IconSize;
        this.Margin = Margin;
        this.PictureDisplay = PictureDisplay;
        this.PictureObjectFit = PictureObjectFit;
        this.RibbonColor = RibbonColor;
        this.RibbonOrientation = RibbonOrientation;
        this.RibbonPlacement = RibbonPlacement;
        this.EntryAction = EntryAction;
        this.THUMBNAIL_LIMIT = 5;
        this.currentEntryIndex = 0;
        this.totalPrice = 0;
        this.thumbnails = [];
    }
    ContestMultiAwardModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        var _a;
        var buyEntries;
        // The first entry on the list is awarded, the rest of the entries are bought
        _a = this.entries, this.awardedEntry = _a[0], buyEntries = _a.slice(1);
        this.buyEntriesDetails = buyEntries.map(function (entry) {
            var amount = 0;
            if (entry.sellPrice) {
                amount = entry.sellPrice;
            }
            else if (_this.contest.prize) {
                amount = _this.contest.prize;
            }
            return { entry: entry, sellPrice: amount };
        });
        this.thumbnails = this.getThumbnails();
        this.totalPrice = this.getTotalPrice();
    };
    ContestMultiAwardModalComponent.prototype.getThumbnails = function () {
        return this.entries.map(function (entry) { return ({
            src: entry.files[0].thumbnail80Url || '',
            alt: ' ',
        }); });
    };
    ContestMultiAwardModalComponent.prototype.getTotalPrice = function () {
        return this.buyEntriesDetails
            .map(function (entryDetails) { return entryDetails.sellPrice; })
            .reduce(function (totalAmount, entrySellPrice) { return totalAmount + entrySellPrice; });
    };
    ContestMultiAwardModalComponent.prototype.onMultiAwardEntries = function () {
        var _this = this;
        if (!this.contest.isPrizeAutodistributed) {
            var entryDoc = this.datastore.document('contestViewEntries', this.awardedEntry.id);
            this.awardEntryPromise = entryDoc
                .update({
                status: EntryStatusApi.WON,
            })
                .catch(function (e) { return (__assign({ status: 'error', errorCode: 'UNKNOWN_ERROR' }, e)); });
            this.awardEntryPromise
                .then(function (awardResponse) {
                if (awardResponse.status !== 'success') {
                    throw awardResponse;
                }
                return _this.buyEntriesDetails.map(function (entryDetails) {
                    return _this.transformEntryToCartItem(entryDetails.entry, entryDetails.sellPrice);
                });
            })
                .then(function (cartItems) {
                return (_this.buyEntriesPromise = _this.cart.handle("Multiaward for  " + _this.contest.id, {
                    destination: DestinationApi.CONTEST_VIEW_PAGE,
                    payload: "" + _this.contest.id,
                }, cartItems));
            });
        }
    };
    ContestMultiAwardModalComponent.prototype.transformEntryToCartItem = function (entry, amount) {
        return {
            contextType: ContextTypeApi.CONTEST_ENTRY_BUY,
            contextId: "" + entry.id,
            description: "Buy Entry #" + entry.number,
            currencyId: this.contest.currency.id,
            amount: amount,
        };
    };
    ContestMultiAwardModalComponent.prototype.onSlideChange = function (index) {
        this.currentEntryIndex = index;
    };
    return ContestMultiAwardModalComponent;
}());
export { ContestMultiAwardModalComponent };
